import React from 'react';
import { Button } from '@material-ui/core';

import { styles } from './styles';

function BaseButton({ children, btnStyle, ...props }) {
  const classes = styles({ ...props });
  return (
    <Button
      {...props}
      variant="contained"
      disableElevation
      className={`${classes.root} ${classes[btnStyle]}`}
      disabled={props.disabled || btnStyle === 'disabled'}
    >
      {children}
    </Button>
  );
}

export function PrimaryButton({ ...props }) {
  return BaseButton({ btnStyle: 'primary', ...props });
}

export function SecondaryButton({ ...props }) {
  return BaseButton({ btnStyle: 'secondary', ...props });
}

export function DeleteButton({ ...props }) {
  return BaseButton({ btnStyle: 'delete', ...props });
}

export function DisabledButton({ ...props }) {
  return BaseButton({ btnStyle: 'disabled', ...props });
}

export function UnsubscribeButton({ ...props }) {
  return BaseButton({ btnStyle: 'unsubscribe', ...props });
}
